import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { AppValidators } from 'src/app/common/appValidators';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { AiInLineActivityFiltersModel } from 'src/app/models/filters/implementations/pageFilters/aiInLineActivityFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-ai-inline-activity-filters',
  templateUrl: './ai-inline-activity-filters.component.html',
  styleUrls: ['./ai-inline-activity-filters.component.scss'],
})
export class AiInlineActivityFiltersComponent implements OnInit {
  @Input() public pageFilters: AiInLineActivityFiltersModel;

  public clearCustomViewSelection$ = new BehaviorSubject(undefined);

  public selectedOptions: ISelectOption[] = [];

  public searchBoxNewValue = new ReplaySubject<string | undefined>(1);
  public fromDateNewValue = new ReplaySubject<Date | undefined>(1);
  public toDateNewValue = new ReplaySubject<Date | undefined>(1);
  public searchValidators = [AppValidators.evenNumberOfQuoteMarks];
  public minDate = DateTime.now().minus({ months: 3 }).toJSDate();

  private _customViewTriggered = false;

  constructor(
    public featureFlagService: FeatureFlagsService,
    private readonly _destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.pageFilters.onUpdate$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((data) => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();

      this.fromDateNewValue.next(data.fromDate);
      this.toDateNewValue.next(data.toDate);

      if (this._customViewTriggered) {
        this._customViewTriggered = false;
      } else {
        this.clearCustomViewSelection$.next(undefined);
      }
    });
  }

  public fromDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FromDate, value);
  }

  public toDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.ToDate, value);
  }
}
